var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marquee"},[_c('div',{staticClass:"marquee__track"},_vm._l((_vm.doubledItems),function(item,i){return _c('span',{key:i,staticClass:"marquee__item"},[_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }